<template>
  <div id="container">
    <div class="column">
      <h2>Markdown</h2>
      <textarea id="editor" @keyup="textarea_keyup" v-model="content"></textarea>  
    </div>
    
    <div class="column">
      <h2>Preview</h2>
      <div id="preview" v-html="content_markdown"></div>  
    </div>
  </div>
</template>


<script>
  const marked = require('marked');
  marked.setOptions({
    breaks: true
  })
  
  let defaultMD = `# Header 1
## Header 2

Link Example: [This is a Link!](http://freecodecamp.org)

Just some sameple text
So sampley!
Look at them linebreaks!

Inline Code: \`Inline Code\` Is here!

\`\`\`
Code Block here!
\`\`\`

* List Item 1
* List Item 2
* List Item 3

> Blockquote Example

**Bold Text**  

Image:
![](https://picsum.photos/200/300)
`;

  export default {
    name: 'MarkdownPreview',
    data: function () {
      this.content = defaultMD;
      this.content_markdown = marked(defaultMD, {breaks: true});
      return {
        content: this.content,
        content_markdown: this.content_markdown
      }
    },
    methods: {
      textarea_keyup: function () {
        this.content_markdown = marked(this.content, {breaks: true});
      }        
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  #container {
    display: flex;
    height: 80vh;
  }
  
  .column {
    box-sizing: border-box;
    width: 50%;
    margin: 5px;
    flex-grow: 1;
  }
  
  #editor {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
  }
  
  #preview {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    border: 1px solid black;
    padding: 5px;
  }
</style>
